import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, subtitle, testid }) => (
  <section className="relative pt-40 pb-16 overflow-hidden" style={{ background: "var(--elsa-blue)" }} data-testid={testid}>
    <div className="absolute inset-0 grain" />
    <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-10">
      <motion.p
        initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="text-sm tracking-[0.3em] uppercase mb-5 text-white/55"
      >
        {eyebrow}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="font-serif text-white text-5xl md:text-7xl leading-[0.9] tracking-tight"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}
          className="text-white/75 text-lg max-w-2xl mt-6 text-balance"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
